export default __webpack_public_path__ + "static/media/Group 75.9d01dd2f.svg";